import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import LandingPage from "@/pages/LandingPage";

// New Pacific church/community SEO pages
import SamoanChurchUniforms from "@/pages/SamoanChurchUniforms";
import TonganChurchUniforms from "@/pages/TonganChurchUniforms";
import CookIslandsUniforms from "@/pages/CookIslandsUniforms";
import ChurchConferenceUniforms from "@/pages/ChurchConferenceUniforms";
import ReunionPoloShirts from "@/pages/ReunionPoloShirts";
import ChurchUniformsAuckland from "@/pages/ChurchUniformsAuckland";

// Legacy SEO pages (kept for indexing)
import CustomRugbyUniformsNZ from "@/pages/CustomRugbyUniformsNZ";
import CustomUniformsAuckland from "@/pages/CustomUniformsAuckland";
import CustomBasketballJerseysNZ from "@/pages/CustomBasketballJerseysNZ";
import FastTshirtPrintingAuckland from "@/pages/FastTshirtPrintingAuckland";
import BulkCustomTshirtsNZ from "@/pages/BulkCustomTshirtsNZ";

import BlogIndex from "@/pages/BlogIndex";
import BlogPost from "@/pages/BlogPost";
import ScrollToTop from "@/components/ScrollToTop";

function ScrollResetWrapper({ children }) {
  const { pathname } = useLocation();
  return (
    <>
      <ScrollToTop pathname={pathname} />
      {children}
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollResetWrapper>
            <Routes>
              <Route path="/" element={<LandingPage />} />

              {/* Pacific church/community SEO pages */}
              <Route path="/samoan-church-uniforms" element={<SamoanChurchUniforms />} />
              <Route path="/tongan-church-uniforms" element={<TonganChurchUniforms />} />
              <Route path="/cook-islands-uniforms" element={<CookIslandsUniforms />} />
              <Route path="/church-conference-uniforms" element={<ChurchConferenceUniforms />} />
              <Route path="/reunion-polo-shirts" element={<ReunionPoloShirts />} />
              <Route path="/church-uniforms-auckland" element={<ChurchUniformsAuckland />} />

              {/* Legacy pages */}
              <Route path="/custom-rugby-uniforms-nz" element={<CustomRugbyUniformsNZ />} />
              <Route path="/custom-uniforms-auckland" element={<CustomUniformsAuckland />} />
              <Route path="/custom-basketball-jerseys-nz" element={<CustomBasketballJerseysNZ />} />
              <Route path="/fast-tshirt-printing-auckland" element={<FastTshirtPrintingAuckland />} />
              <Route path="/bulk-custom-tshirts-nz" element={<BulkCustomTshirtsNZ />} />

              <Route path="/blog" element={<BlogIndex />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="*" element={<LandingPage />} />
            </Routes>
          </ScrollResetWrapper>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "#0a1530",
              border: "1px solid #1f3370",
              color: "#ffffff",
              borderRadius: 0,
            },
          }}
        />
      </div>
    </HelmetProvider>
  );
}

export default App;
